module.exports = __webpack_public_path__ + "img/square-phone-hangup.cb3061a2.svg";